var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input--file" }, [
    _c("div", { staticClass: "input__wrapper" }, [
      _c(
        "div",
        { staticClass: "grid grid--ai-middle" },
        [
          _c(
            "button",
            {
              staticClass: "mainYellow",
              attrs: { disabled: _vm.file },
              on: { click: _vm.handleSelectFileClick }
            },
            [_vm._v(_vm._s(_vm.$t("actions.select")))]
          ),
          _c("p", { staticClass: "text-medium black mg mg--l-2" }, [
            _vm._v(_vm._s(_vm._f("textOverflow")(_vm.comFileName, 40)))
          ]),
          _c("input", {
            ref: _vm.name,
            attrs: {
              type: "file",
              name: _vm.name,
              accept: _vm.mimetypeAccepted
            },
            on: { change: _vm.handleInputChange }
          }),
          _vm.file
            ? _c("svgicon", {
                staticClass: "svg-icon-action mg mg--l-4",
                attrs: { name: "delete", height: "16", width: "16" },
                on: { click: _vm.handleDeleteFile }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }